/**
 * @class Oskari.framework.bundle.oskariui.DomManager
 *

 */
Oskari.clazz.define('Oskari.framework.bundle.oskariui.DomManager',
/**
 * @method create called automatically on construction
 * @static
 * @param {jQuery} jquery impl
 */

function (dollar, partsMap) {
  this.$ = dollar;
  this.partsMap = partsMap || {};
  this.layout = null;
  this.layouts = [];
}, {
  getEl: function getEl(selector) {
    return this.$(selector);
  },
  getElForPart: function getElForPart(part) {
    return this.$(this.partsMap[part]);
  },
  setElForPart: function setElForPart(part, el) {
    this.partsMap[part] = this.$(el);
  },
  setElParts: function setElParts(partsMap) {
    this.partsMap = partsMap;
  },
  getElParts: function getElParts() {
    return this.partsMap;
  },
  pushLayout: function pushLayout(l) {
    if (this.layout) {
      this.layout.removeLayout(this);
    }
    this.layout = l;
    this.layouts.push(l);
    l.applyLayout(this);
  },
  popLayout: function popLayout() {
    var l = this.layouts.pop();
    if (l) {
      l.removeLayout(this);
    }
    if (this.layouts.length === 0) {
      this.layout = null;
      return;
    }
    l = this.layouts[this.layouts.length - 1];
    this.layout = l;
    l.applyLayout(this);
  },
  getLayout: function getLayout() {
    return this.layout;
  }
}, {
  /**
   * @property {String[]} protocol array of superclasses as {String}
   * @static
   */
  'protocol': ['Oskari.dom.DomManager']
});